import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AttributeValue} from './attributes.model';
import {Type} from '../../pages/product/product.model';

@Component({
    selector: 'attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributesComponent implements OnInit {


    constructor() { }

    @Input() public values: Array<AttributeValue>;

    @Input() public type: Type;

    @Input() public form: FormGroup;

    toppingsControl = new FormControl([]);
    // toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];

    private static removeFirst<T>(array: T[], toRemove: T): void {
        const index = array.indexOf(toRemove);
        if (index !== -1) {
            array.splice(index, 1);
        }
    }

    ngOnInit(): void {
        this.toFormGroup(this.values);
    }

    // ngOnDestroy(){
    //     this.getAttributes();
    // }

    toFormGroup(attributes: Array<AttributeValue> ): void {
        // const group: any = {};
        // this.allAttributes = [];

        attributes.forEach(att => {
            /// group[att.name] = att.attributeType.required ? new FormControl(att.value || '', Validators.required)
            //                                  : new FormControl(att.value || '');
            // this.theForm.addControl(att.name,att.attributeType.required 
            //         ? new FormControl(att.value || '', Validators.required)
            //         : new FormControl(att.value || ''));
            if (att.name){
                let control: FormControl;
                if (att.attributeType.multiValue){
                    const values: string[] = att.value ? att.value.split(',') : [];
                    control = new FormControl(values);
                    control.valueChanges.subscribe(theValues => {
                        att.value = theValues.join();
                    });
                }else {
                    control = new FormControl(att.value);
                    control.valueChanges.subscribe(value => {
                        att.value = value;
                    });
                }
                this.form.addControl(att.name, control);
            }

        });
        // this.theForm.addControl('Datos Específicos',new FormGroup(group))

    }

    onToppingRemoved(topping: string): void {
        const toppings = this.toppingsControl.value as string[];
        AttributesComponent.removeFirst(toppings, topping);
        this.toppingsControl.setValue(toppings); // To trigger change detection
    }

    isValid(): boolean{
        return true;
    }

    compareFunction(o1: any, o2: any): boolean {
        return (o1 === o2);
    }

    // getAttributes():Array<AttributeValue>{
    //     return this.allAttributes;
    // }



}
